import ClientsList from './ClientsList';

export default ClientsList;
